import { Box, Text, Flex, Grid, GridItem, Button, Image, IconButton, Badge, Tooltip } from '@chakra-ui/react'
import { MdCameraAlt, MdDelete } from 'react-icons/md'
import { BsCheckCircleFill, BsInfoCircle } from 'react-icons/bs'

export function PhotoUpload({ photos, openCamera, removePhoto, allPhotosTaken }) {
  return (
    <Box mb={6} p={6} shadow="md" borderWidth="1px" borderRadius="lg" bg="#3a4a53" color="white">
      <Flex justify="space-between" align="center" mb={4}>
        <Text fontSize="lg" fontWeight="bold">
          Fotos do Produto
        </Text>
        <Badge colorScheme={allPhotosTaken() ? 'green' : 'yellow'} px={2} py={1} borderRadius="full">
          {allPhotosTaken() ? '3/3 fotos' : `${photos.filter((p) => p !== null).length}/3 fotos`}
        </Badge>
      </Flex>

      <Text fontSize="sm" mb={4} color="gray.300">
        <Flex align="center" gap={2}>
          <BsInfoCircle />
          <span>Tire 3 fotos do produto para solicitar a troca. Recomendamos fotos de diferentes ângulos.</span>
        </Flex>
      </Text>

      <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={4} mb={4}>
        {[0, 1, 2].map((index) => (
          <GridItem key={index}>
            <Box
              bg="#272f33"
              borderRadius="md"
              overflow="hidden"
              position="relative"
              height="200px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderWidth={1}
              borderColor={photos[index] ? '#37F091' : 'gray.600'}
              borderStyle="dashed"
            >
              {photos[index] ? (
                <>
                  <Image src={photos[index].preview} alt={`Foto ${index + 1}`} objectFit="cover" w="100%" h="100%" />
                  <Tooltip label="Remover foto" placement="top">
                    <IconButton
                      icon={<MdDelete size={20} />}
                      colorScheme="red"
                      size="sm"
                      aria-label="Remover foto"
                      position="absolute"
                      top={2}
                      right={2}
                      onClick={() => removePhoto(index)}
                      opacity={0.8}
                      _hover={{ opacity: 1 }}
                    />
                  </Tooltip>
                </>
              ) : (
                <Flex direction="column" align="center">
                  <Button
                    leftIcon={<MdCameraAlt />}
                    onClick={() => openCamera(index)}
                    variant="outline"
                    borderColor="#37F091"
                    color="#37F091"
                    _hover={{
                      bg: 'rgba(55, 240, 145, 0.1)',
                    }}
                  >
                    Tirar Foto {index + 1}
                  </Button>
                </Flex>
              )}
            </Box>
          </GridItem>
        ))}
      </Grid>

      <Text fontSize="sm" color="gray.400" textAlign="center">
        {allPhotosTaken() ? (
          <Flex align="center" justify="center" color="#37F091" gap={2}>
            <BsCheckCircleFill />
            <span>Todas as fotos foram tiradas!</span>
          </Flex>
        ) : (
          'Tire as 3 fotos para continuar'
        )}
      </Text>
    </Box>
  )
}
